function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.85589 16C9.62497 16.0014 9.39606 15.9569 9.18248 15.8688C8.9689 15.7808 8.7749 15.6511 8.61176 15.4873L0.452772 7.18656C0.189606 6.92364 0.0301622 6.5742 0.00386346 6.20269C-0.0224352 5.83119 0.0861834 5.46268 0.309676 5.16515L3.6684 0.676105C3.83103 0.463459 4.04081 0.291673 4.28112 0.174341C4.52143 0.057009 4.78568 -0.00264888 5.05297 9.02313e-05H14.9503C15.2177 -0.00249328 15.482 0.0573699 15.7223 0.174936C15.9626 0.292502 16.1724 0.464542 16.3349 0.677432L19.6883 5.15851C19.9156 5.45917 20.0248 5.83302 19.9953 6.20908C19.9657 6.58514 19.7994 6.93724 19.528 7.19851L11.0788 15.5072C10.7513 15.8258 10.3122 16.0027 9.85589 16ZM2.05728 6.05898L9.85456 13.9918L17.9367 6.04703L14.8642 1.94048H5.14306L2.05728 6.05898Z",
  fill: "#1565c0"
});

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.5036fb69.svg";
export { ForwardRef as ReactComponent };